/** sessionStorage key for Spacey V2 chat (per browser tab). */
export const SPACEY_SESSION_KEY = 'spacey_v2_session';

/** User dismissed the launcher speech bubble (per tab). */
export const SPACEY_BUBBLE_DISMISSED_KEY = 'spacey_bubble_dismissed';

export const isSpeechBubbleDismissed = () => {
  try {
    return sessionStorage.getItem(SPACEY_BUBBLE_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
};

export const setSpeechBubbleDismissed = () => {
  try {
    sessionStorage.setItem(SPACEY_BUBBLE_DISMISSED_KEY, '1');
  } catch {
    // ignore
  }
};

/**
 * Persists messages and LLM history for restore when the popup reopens.
 * Omits in-flight loading bubbles.
 */
export const saveChatSession = ({ messages, agentHistory, countryCode }) => {
  try {
    const persistable = (messages || []).filter((m) => !m.isLoading);
    if (persistable.length === 0) return;

    sessionStorage.setItem(
      SPACEY_SESSION_KEY,
      JSON.stringify({
        messages: persistable,
        agentHistory: agentHistory || [],
        countryCode: countryCode || null,
      })
    );
  } catch {
    // Quota or private mode — ignore
  }
};

/**
 * @param {string} [expectedCountryCode] - When set, ignores saved session from another market.
 * @returns {{ messages: Array, agentHistory: Array } | null}
 */
export const loadChatSession = (expectedCountryCode) => {
  try {
    const raw = sessionStorage.getItem(SPACEY_SESSION_KEY);
    if (!raw) return null;

    const data = JSON.parse(raw);
    if (!Array.isArray(data.messages) || data.messages.length === 0) return null;

    if (expectedCountryCode && data.countryCode && data.countryCode !== expectedCountryCode) {
      sessionStorage.removeItem(SPACEY_SESSION_KEY);
      return null;
    }

    return {
      messages: data.messages.map((m) => ({
        ...m,
        timestamp: m.timestamp ? new Date(m.timestamp) : new Date(),
      })),
      agentHistory: Array.isArray(data.agentHistory) ? data.agentHistory : [],
    };
  } catch {
    return null;
  }
};

export const clearChatSession = () => {
  try {
    sessionStorage.removeItem(SPACEY_SESSION_KEY);
  } catch {
    // ignore
  }
};
